import { render, staticRenderFns } from "./ConfigCreate.vue?vue&type=template&id=770c0c0e&"
import script from "./ConfigCreate.vue?vue&type=script&lang=ts&"
export * from "./ConfigCreate.vue?vue&type=script&lang=ts&"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./ConfigCreate.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-ca-tester/mfe-ca-tester/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('770c0c0e')) {
      api.createRecord('770c0c0e', component.options)
    } else {
      api.reload('770c0c0e', component.options)
    }
    module.hot.accept("./ConfigCreate.vue?vue&type=template&id=770c0c0e&", function () {
      api.rerender('770c0c0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ConfigCreate.vue"
export default component.exports